import { render, staticRenderFns } from "./PaxSuggestionResult.vue?vue&type=template&id=fa100c8e&"
import script from "./PaxSuggestionResult.vue?vue&type=script&lang=js&"
export * from "./PaxSuggestionResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports